import React, {memo, useEffect, useState} from "react";
import {ProductBasicInfo, ModelUploader, ProductEditSeo, ProductPins} from "../../components";
import {Box} from "@mui/material";
import Api from "../../utils/api";
import {connect} from "react-redux";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import ProductEditCategory from "../../components/Product/EditCategory";
import ProductEditAttribute from "../../components/Product/EditAttribute";
import ProductEditFilter from "../../components/Product/EditFilter";
import StepButton from '@mui/material/StepButton';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {Paper} from '@mui/material'
import './style.css'
import ProductTypes from "../../components/Product/types";
import HeadLine from "../../components/HeadLine/headLine";
import Comment from "../../components/Product/comments";
import {useParams} from "react-router-dom";

const actions = [
    { name: 'اطلاعات اولیه', 'step' : 0 },
    { name: 'محتویات و سئو', 'step' : 1 },
    { name: 'دسته بندی', 'step' : 2 },
    { name: 'ویژگی های محصول', 'step' : 3 },
    { name: 'فیلترهای دلخواه', 'step' : 4 },
    { name: 'گالری تصاویر', 'step' : 5 },
    { name: 'تنوع محصول و قیمت گذاری', 'step' : 6 },
    { name: 'موجودی و انبار', 'step' : 7 },
    { name: 'نظرات کاربران', 'step' : 8 },
];

const ProductUpdateOrCreate = memo((props) => {

    const { id } = useParams();

    const state = props.history?.location?.state
    const [step, setStep] = useState(state || 0);
    const [productID, setProductID] = useState(id ? id : null);
    const name = localStorage.getItem("p-name")
    const [title, setTitle] = useState("");

    useEffect(() => {
        new Api().get('/products/' + productID + '/init').then((response) => {
            if (typeof response !== "undefined") {
                setTitle(response.title)
            }
        })
    } ,[])

    const switchStep = () => {
        switch (step) {
            case 0:
                return (<ProductBasicInfo productID={productID} onComplete={(productID) => {
                    setProductID(productID);
                    setStep(step + 1);
                }}/>);
                break;
            case 1:
                return (<ProductEditSeo productID={productID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 2:
                return (<ProductEditCategory productID={productID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 3:
                return (<ProductEditAttribute productID={productID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 4:
                return (<ProductEditFilter productID={productID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 5:
                return (<ModelUploader model={'product'} entityID={productID} onComplete={() => {
                    setStep(step + 1);
                }}/>);
                break;
            case 6:
                return (<ProductTypes onComplete={() => {
                    setStep(step + 1);
                }} productID={productID}/>);
                break;
            case 7:
                return (<ProductPins onComplete={() => {
                    setStep(7);
                }} productID={productID}/>);
                break;
            case 8:
                return (<Comment onComplete={() => {
                    setStep(8);
                }} productID={productID}/>);
                break;

        }
    };


    const handleChangeTab = (event, newValue) => {
        setStep(newValue);
    };
    return(
        <div style={{ padding: '0 20px'}}>
            {
                title &&
                <HeadLine
                    link={`https://digiattar.com/product/${productID}`}
                    title={title}
                    subTitle={"مراحل را جهت ایجاد و یا ویرایش محصول طی کنید."}
                />
            }

            <Box mt={5} className={'product'}>
                {!id ? <Stepper elevation={1} alternativeLabel activeStep={step}>
                    {actions.map((item, index) => {
                        return(<Step key={item.step}>
                            <StepButton onClick={() => {
                                if (productID) {
                                    setStep(item.step)
                                }
                            }}>
                                <StepLabel>
                                    <span>{item.name}</span><br/>
                                </StepLabel>
                            </StepButton>
                        </Step>);
                    })}
                </Stepper> : <Paper>
                    <Tabs
                        variant="scrollable"
                        scrollButtons="auto"
                        value={step}
                        onChange={handleChangeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        dir={'rtl'}
                        centered={true}
                    >
                        {actions.map((item) => {
                            return(
                                <Tab label={item.name} />
                            );
                        })}

                    </Tabs>
                </Paper>}
                {switchStep()}
            </Box>
        </div>
    );
})

const mapStateToProps = state => ({
    authReducer : state.authReducer
})

export default connect(mapStateToProps)(ProductUpdateOrCreate);